

export function generateAdvisorSchema(advisor) {

    const specialty = advisor.specialities.map((item) => {
        return item.value;
    })

    const serviceType = advisor.services.map((item) => {
        return item.value;
    })

    const audience = advisor.clientele.map((item) => {
        return item.value;
    })

    const priceRange = advisor.pricing.map((item) => {
        return {
            "@type": "PriceSpecification",
            "priceType": `${item.value}`,
            "price": "",
            "priceCurrency": "USD"
        }
    })

    const credentials = advisor.credentials.map((item) => {
        return {
            "@type": "EducationalOccupationalCredential",
            "credentialCategory": `${item.value}`
        }
    })

    const education = advisor.education.map((item) => {
        return {
            "@type": "EducationalOrganization",
            "name": `${item.institution}`
        }
    })

    let schema = {
        "@context": "http://schema.org",
        "@type": "Person",
        "name": `${advisor.firstName} ${advisor.lastName}`,
        "jobTitle": `${advisor.jobTitle}`,
        "address": {
            "@type": "PostalAddress",
            "addressLocality": `${advisor.city}`,
            "addressRegion": `${advisor.state}`
        },
        "memberOf": {
            "@type": "Organization",
            "name": `${advisor.companyName}`
        },
        "description": `${advisor.bio}`,
        "serviceArea": {
            "@type": "AdministrativeArea",
            "name": `${advisor.city}, ${advisor.state}`
        },
        "serviceType": serviceType,
        "specialty": specialty,
        "audience": audience,
        "priceRange": priceRange,
        "credentials": credentials,
        "alumniOf": education
    }

    return schema


}